<template>
  <section class="app-main" style="height:100%">
    <transition :name="transitionName">
      <router-view
        :class="transitionName != 'none' ? 'child-view' : ''"
        :key="key"
      />
    </transition>
  </section>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Layout",
  computed: {
    key() {
      return this.$route.path;
    },
    ...mapState({
      direction: (state) => state.settings?.direction || "forward",
    }),
  },
  watch: {
    $route: {
      immediate: true, // 确保在组件创建时立即执行一次
      handler(to, from) {
        // 确保 direction 有默认值，防止 undefined
        const direction = this.direction || 'forward';
        
        if (direction === "none") {
          this.transitionName = "none";
        } else if (direction === "forward") {
          this.transitionName = "slide-left";
        } else {
          this.transitionName = "slide-right";
        }
      }
    },
  },
  data() {
    return {
      transitionName: "",
    };
  },
};
</script>

<style scoped>
.child-view {
  position: absolute;
  width: 100%;
  transition: all 0.8s cubic-bezier(0.55, 0, 0.1, 1);
  height: 100vh;
  overflow-y: auto;
}
.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  -webkit-transform: translate(50px, 0);
  transform: translate(50px, 0);
}
.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  -webkit-transform: translate(-50px, 0);
  transform: translate(-50px, 0);
}
</style>